import { DialogContent, Divider } from "@mui/material";
import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

type IconDialogContentProps = {
    icon: IconProp;
    children: React.ReactNode;
    iconColor?: string;
};

export const IconDialogContent = ({ icon, iconColor, children }: IconDialogContentProps) => (
    <React.Fragment>
        <DialogContent style={{ padding: "1.5em", display: "flex", alignItems: "center" }}>
            <FontAwesomeIcon icon={icon} size="2x" style={{ marginRight: "0.7em", color: iconColor }} />
            <div style={{ marginRight: "0.3em" }}>{children}</div>
        </DialogContent>
        <Divider />
    </React.Fragment>
);
